import request from '@/utils/axios';

export const banners        = ()    => request.get('/community/open/banner');
export const myBanners        = ()    => request.get('/community/banner');
export const setBanner      = p     => request.post('/community/banner', p);
export const removeBanner   = bid   => request.delete(`/community/banner/${bid}`);
